/**
 * @file 详情页
 */
import { useEffect } from 'react';
import { Content } from '@/containers/report';
import { GetStaticProps, GetStaticPaths } from 'next';
import { ALL_LOCALES } from '@web3/base-utils';
import { getMessage } from '@web3/base-lang';
import { usePermission } from '@web3fe/infra';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

import styles from './index.module.scss';

export default function Index() {
  const { countryCode } = usePermission();

  useEffect(() => {
    if (!countryCode) return;

    scTrack(Event.HackbountyPageView, {
      page_name: Page.BountySubmitPage,
      ip: countryCode,
    });
  }, [countryCode]);

  return (
    <div className={styles.container}>
      <Content />
    </div>
  );
}

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale } = context.params as any;

  const messages = await getMessage(
    'web3-tracer',
    {
      locale: 'en',
      entry: import.meta.url,
      additions: ['seoTitle', 'seoDes', 'seoKeywords'],
    },
    false
  );

  return {
    props: {
      locale,
      messages: messages || {},
    },
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ALL_LOCALES.map((locale) => ({
      params: {
        locale: locale.value,
      },
    })),
    fallback: true,
  };
};
